'use strict';

var _ = require('lodash');
var DistributeUserValueService = function DistributeUserValueService() {
  function getProcessingChunkKey(item) {
    return item.classGroup + '-' + item.departureDate + '-' + item.significantPOS;
  }
  function distributeWithUserAdjustments(serviceShareModel, serviceShareUserGrouped, userAdj) {
    var sum = _.sumBy(serviceShareModel, 'value');
    _.forEach(serviceShareModel, function (service) {
      serviceShareUserGrouped[service.groupId].value = sum === 0 ? userAdj / serviceShareModel.length : service.value * userAdj / sum;
    });
  }
  function distributeWithoutUserAdjustments(serviceShareUserValuesForClassGroupAndDepartureDate, processingChunkKey, serviceShareModel, serviceShareUserGrouped) {
    var allUserValuesDefinedInGroup = _.every(serviceShareUserValuesForClassGroupAndDepartureDate[processingChunkKey], function (share) {
      return !_.isNil(share.value);
    });
    if (allUserValuesDefinedInGroup) {
      _.forEach(serviceShareModel, function (service) {
        serviceShareUserGrouped[service.groupId].value = null;
      });
    }
  }
  function distribute(groupShareDataUser, serviceShare) {
    var serviceShareUserGrouped = _.keyBy(serviceShare.user, 'groupId');
    _.forEach(groupShareDataUser, function (g) {
      var userAdjustment = g.value;
      var serviceShareModelValuesForGroupId = _.filter(serviceShare.model, ['bucketId', g.groupId]);
      var serviceShareModelValuesProcessingChunk = _.groupBy(serviceShareModelValuesForGroupId, getProcessingChunkKey);
      var serviceShareUserValuesForGroupId = _.filter(serviceShare.user, ['bucketId', g.groupId]);
      var serviceShareUserValuesForClassGroupAndDepartureDate = _.groupBy(serviceShareUserValuesForGroupId, getProcessingChunkKey);
      _.forEach(serviceShareModelValuesProcessingChunk, function (serviceShareModel, processingChunkKey) {
        if (!_.isNil(userAdjustment)) {
          distributeWithUserAdjustments(serviceShareModel, serviceShareUserGrouped, userAdjustment);
        } else {
          distributeWithoutUserAdjustments(serviceShareUserValuesForClassGroupAndDepartureDate, processingChunkKey, serviceShareModel, serviceShareUserGrouped);
        }
      });
    });
  }
  return {
    distribute: distribute
  };
};
DistributeUserValueService.$inject = [];
module.exports = DistributeUserValueService;